import { useTrans } from "@/translations";

type Props = {
  title: string;
  subtitle?: string;
};

export const CardText: React.FC<Props> = ({ title, subtitle }) => {
  const { t } = useTrans();

  return (
    <div>
      <div className="font-dm-sans text-[18px] font-bold">{t(title)}</div>
      {!!subtitle && (
        <div className="font-dm-sans text-grey6 text-[12.5px]">
          {t(subtitle)}
        </div>
      )}
    </div>
  );
};
